import React from 'react'
import { FormattedHTMLMessage, Menu, AppSvg, newIcons, NavMenuItem } from '@web/walter-ui-kit'

import { lang } from './lang'
import s from './s.module.css'
import { generateUrl } from '~utils/navigation/generateUrl'
import { Routes } from '~constants/routes'
import { useCurrencies } from '~api'

interface Props {
    currency?: string
    showSwap?: boolean
    showReceive?: boolean
}

function QuickMenu({ currency, showSwap, showReceive }: Props) {
    const { data: currencies } = useCurrencies()

    const currencyObj = currencies?.[currency || '']

    return (
        <div className={s.menu}>
            <Menu>
                {showReceive && (
                    <NavMenuItem
                        dataPointer="receive"
                        icon={<AppSvg path="new-icons" svgName={newIcons.ic24ArrowDown} size={24} />}
                        type="button"
                        onClick={() =>
                            window.open(
                                generateUrl({
                                    route: Routes.receive,
                                    fromCurrency: currency || '',
                                    type: currencyObj?.crypto ? 'crypto' : 'fiat',
                                }),
                                '_blank'
                            )
                        }
                    >
                        <div className={s.tab}>
                            <FormattedHTMLMessage
                                {...lang.receiveTitle}
                                className={s.tabTitle}
                                values={{ currencyCode: currency }}
                            />
                            <FormattedHTMLMessage
                                {...lang.receiveDescription}
                                className={s.tabDescription}
                                values={{ currencyCode: currency }}
                            />
                        </div>
                    </NavMenuItem>
                )}
                {showSwap && (
                    <NavMenuItem
                        icon={<AppSvg path="new-icons" svgName={newIcons.ic24Swap} size={24} />}
                        dataPointer="swap"
                        type="button"
                        onClick={() =>
                            window.open(
                                generateUrl({
                                    route: Routes.swap,
                                    toCurrency: currency,
                                }),
                                '_blank'
                            )
                        }
                    >
                        <div className={s.tab}>
                            <FormattedHTMLMessage
                                {...lang.swapTitle}
                                className={s.tabTitle}
                                values={{ currencyCode: currency }}
                            />
                            <FormattedHTMLMessage
                                {...lang.swapDescription}
                                className={s.tabDescription}
                                values={{ currencyCode: currency }}
                            />
                        </div>
                    </NavMenuItem>
                )}
            </Menu>
        </div>
    )
}

export default QuickMenu
